import { AfterContentInit, Directive, ElementRef, Renderer2 } from '@angular/core';

import { buildInfo } from '../../../environments/environment';

@Directive({
    selector: '[privaAppVersionAttributes]',
})
export class PrivaAppVersionAttributes implements AfterContentInit {
    renderer: Renderer2;
    el: ElementRef;

    constructor(renderer: Renderer2, el: ElementRef) {
        this.renderer = renderer;
        this.el = el;
    }

    ngAfterContentInit() {
        const privaAppElement: ElementRef = this.el.nativeElement.closest('analytics-app');

        this.renderer.setAttribute(privaAppElement, 'app-version', buildInfo.version);
        this.renderer.setAttribute(privaAppElement, 'app-name', buildInfo.name);
        this.renderer.setAttribute(privaAppElement, 'app-build-date', buildInfo.buildDate);
    }
}
